/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppTemplateSync } from '../../axios/whatsAppTemplateSync'
import type {
	WhatsAppTemplateSyncError,
	WhatsAppTemplateSyncPathParams,
	WhatsAppTemplateSyncResponse,
} from '../../types/WhatsAppTemplateSync'

export const whatsAppTemplateSyncMutationKey = () =>
	[{ url: '/organisations/:organisationId/whatsapp-templates/sync' }] as const

export type WhatsAppTemplateSyncMutationKey = ReturnType<typeof whatsAppTemplateSyncMutationKey>

export type WhatsAppTemplateSyncVariables = {
	organisationId: WhatsAppTemplateSyncPathParams['organisationId']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppTemplateController.php WhatsAppTemplateController::sync */
export function useWhatsAppTemplateSync<TContext = unknown>(
	options?: UseMutationOptions<
		WhatsAppTemplateSyncResponse,
		AxiosError<WhatsAppTemplateSyncError>,
		WhatsAppTemplateSyncVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: whatsAppTemplateSyncMutationKey(),
		mutationFn: ({ organisationId }: WhatsAppTemplateSyncVariables) =>
			whatsAppTemplateSync(organisationId, config).then(res => res.data),
		...options,
	})
}
